import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en'
import ro from './locales/ro'

const STORAGE_KEY = 'app-language'
const SUPPORTED_LANGUAGES = ['ro', 'en']

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'ro'
  }

  const savedLanguage = window.localStorage.getItem(STORAGE_KEY)
  if (SUPPORTED_LANGUAGES.includes(savedLanguage)) {
    return savedLanguage
  }

  return 'ro'
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
    },
    lng: getInitialLanguage(),
    fallbackLng: {
      ro: ['ro', 'en'],
      en: ['en'],
      default: ['en'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

i18n.on('languageChanged', language => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, language)
  }
})

export default i18n
